var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4003 9.59996C18.3995 7.91846 17.9169 6.27239 17.0098 4.85659C16.1026 3.4408 14.8088 2.31454 13.2815 1.61115C11.7542 0.907749 10.0573 0.656657 8.39172 0.887591C6.72616 1.11852 5.16162 1.82181 3.8833 2.91421C2.60498 4.00662 1.66639 5.44239 1.17864 7.0516C0.690891 8.66081 0.674394 10.3761 1.1311 11.9944C1.58781 13.6126 2.49861 15.0662 3.75568 16.183C5.01275 17.2998 6.56347 18.033 8.22429 18.296V12.144H5.98429V9.59996H8.22429V7.66396C8.22429 5.45596 9.53629 4.23996 11.5523 4.23996C12.5123 4.23996 13.5203 4.40796 13.5203 4.40796V6.56796H12.4003C11.3043 6.56796 10.9603 7.25596 10.9603 7.95196V9.59996H13.4083L13.0163 12.144H10.9683V18.296C13.0401 17.9699 14.9274 16.9146 16.29 15.3203C17.6526 13.7259 18.401 11.6973 18.4003 9.59996Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.78a84743d46836277acc968f1f91d42c.svg";
export { ForwardRef as ReactComponent };